import { IconAssembling } from "../../../icons/activities/IconAssembling"
import { IconDyeing } from "../../../icons/activities/IconDyeing"
import { IconFinishing } from "../../../icons/activities/IconFinishing"
import { IconManufacturing } from "../../../icons/activities/IconManufacturing"
import { IconStitching } from "../../../icons/activities/IconStitching"
import { IconWeaving } from "../../../icons/activities/IconWeaving"
import { IconProps } from "../../../icons/icon.types"

function getIconComponent(activity: string) {
  const iconMap: { [key: string]: React.FC<IconProps> } = {
    APPAREL_MANUFACTURING: IconManufacturing,
    FABRIC_WEAVING_OR_KNITTING: IconWeaving,
    FABRIC_DYEING_PRINTING: IconDyeing,
    FOOTWEAR_FINISHING: IconFinishing,
    FOOTWEAR_STITCHING: IconStitching,
    FOOTWEAR_ASSEMBLING: IconAssembling,
  }

  return iconMap[activity]
}

export function getActivityIcon({
  activity,
  size = 48,
}: {
  activity: string
  size?: number
}) {
  const IconComponent = getIconComponent(activity)

  if (IconComponent) {
    return <IconComponent size={size} />
  }

  return <IconManufacturing size={size} />
}
